import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiservicepune() {



    const cardData = {

keyword: "Outstation Taxi Service Pune",

headingDescription:
    "Rising Cab Service offers reliable and affordable Outstation Taxi Service in Pune for families, groups, corporate travelers, and tourists planning long-distance journeys. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced and professional chauffeurs for a safe and comfortable travel experience. Our outstation cab service includes one-way and round-trip options with doorstep pickup from Pune, transparent pricing, and 24/7 booking support. Whether it’s a weekend trip, pilgrimage, or holiday travel, Rising Cab Service ensures a smooth and hassle-free journey across India.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is India’s financial capital known for iconic attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and vibrant city life. It is one of the most popular outstation routes from Pune."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a famous hill station near Pune known for green valleys, waterfalls, forts, and scenic monsoon views. It is a top weekend getaway destination for families and couples."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station known for strawberry farms, cool climate, viewpoints, and attractions like Arthur’s Seat and Venna Lake, perfect for family vacations."
    },
    {
        title: "Goa",
        description:
            "Goa is a top tourist destination famous for beaches, nightlife, water sports, and Portuguese heritage. It is one of the most preferred long-distance trips from Pune."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from all over India for spiritual darshan and blessings."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a holy city known for Trimbakeshwar Jyotirlinga, Panchvati, Godavari river ghats, and vineyards, offering both spiritual and leisure experiences."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest and wildlife sanctuary, ideal for pilgrimage and trekking."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is known for Ajanta and Ellora Caves, Bibi Ka Maqbara, and historical forts, making it a major heritage tourism destination from Pune."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for Mahalakshmi Temple, rich culture, historical forts, and traditional cuisine, making it a popular spiritual and cultural destination."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal beach destination known for clean beaches, sea forts, and relaxing weekend trips, ideal for families and groups traveling from Pune."
    }
],



services: [
    {
        name: "Outstation Taxi Service Pune",
        description:
            "Rising Cab Service offers Outstation Taxi Service Pune for safe, reliable, and comfortable long-distance travel to multiple cities across Maharashtra and India. We provide well-maintained AC vehicles, experienced highway drivers, and 24x7 availability for one-way, round-trip, and customized travel plans. Our focus is on punctual pickups, smooth journeys, and transparent pricing for all outstation routes from Pune."
    },
    {
        name: "Pune Outstation Taxi",
        description:
            "Our Pune Outstation Taxi service ensures convenient intercity travel with clean vehicles, professional chauffeurs, and flexible booking options. Whether you are traveling for business, pilgrimage, or leisure, Rising Cab Service guarantees a safe and comfortable journey from Pune to major destinations like Mumbai, Nashik, Goa, Shirdi, and more."
    },
    {
        name: "Long Distance Taxi Pune",
        description:
            "Rising Cab Service provides Long Distance Taxi Pune for extended travel routes with well-maintained cars, trained drivers, and smooth highway driving experience. We ensure comfort, safety, and affordability for long journeys across states and major cities."
    },
    {
        name: "Intercity Taxi Pune",
        description:
            "Book Intercity Taxi Pune with Rising Cab Service for reliable travel between cities with flexible pickup and drop options. Our service is ideal for business trips, family travel, and emergency intercity transportation."
    },
    {
        name: "One Way Taxi Pune Outstation",
        description:
            "Our One Way Taxi Pune Outstation service is designed for travelers who need a single drop without return charges. Enjoy affordable pricing, safe driving, and convenient travel to any outstation destination from Pune."
    },
    {
        name: "Round Trip Taxi Pune",
        description:
            "Rising Cab Service offers Round Trip Taxi Pune for complete travel solutions with return journey convenience, waiting options, and flexible scheduling for outstation trips."
    },
    {
        name: "Outstation Taxi Booking Pune",
        description:
            "Book Outstation Taxi Booking Pune with Rising Cab Service for instant confirmation, multiple vehicle options, and transparent fares. We ensure a smooth booking experience for all intercity travel needs."
    },
    {
        name: "Pune to Outstation Taxi",
        description:
            "Rising Cab Service provides Pune to Outstation Taxi for travel to all major destinations with safe drivers, comfortable vehicles, and reliable service ensuring stress-free journeys."
    },
    {
        name: "Best Outstation Taxi Pune",
        description:
            "Book Best Outstation Taxi Pune with Rising Cab Service for premium travel experience, punctual service, and high-quality vehicles suitable for families, groups, and business travelers."
    },
    {
        name: "Cheap Outstation Taxi Pune",
        description:
            "Our Cheap Outstation Taxi Pune service offers budget-friendly travel options without compromising safety and comfort, making it ideal for economical long-distance trips."
    },
    {
        name: "SUV Outstation Taxi Pune",
        description:
            "Rising Cab Service provides SUV Outstation Taxi Pune with spacious seating, extra comfort, and powerful vehicles perfect for group travel and long highway journeys."
    },
    {
        name: "Sedan Outstation Taxi Pune",
        description:
            "Book Sedan Outstation Taxi Pune for comfortable and affordable travel with clean cars, smooth rides, and experienced drivers for intercity routes."
    },
    {
        name: "Pune Outstation Taxi Fare",
        description:
            "We offer transparent Pune Outstation Taxi Fare with no hidden charges. Pricing depends on distance, vehicle type, and trip duration, ensuring clarity and affordability for all customers."
    },
    {
        name: "Luxury Outstation Taxi Pune",
        description:
            "Rising Cab Service provides Luxury Outstation Taxi Pune with premium vehicles, professional chauffeurs, and high-end comfort for VIP travel, special occasions, and executive trips."
    },
    {
        name: "Corporate Outstation Taxi Pune",
        description:
            "Our Corporate Outstation Taxi Pune service is designed for business travel, employee transportation, and official trips with punctual service, professional drivers, and reliable fleet management."
    },
    {
        name: "Outstation Taxi Service in Pune",
        description:
            "Rising Cab Service offers Outstation Taxi Service in Pune for all types of intercity travel with safe vehicles, experienced drivers, and 24x7 availability for seamless journeys."
    },
    {
        name: "Outstation Taxi in Pune",
        description:
            "Book Outstation Taxi in Pune for reliable long-distance travel with flexible options, comfortable rides, and affordable pricing for all destinations."
    },
    {
        name: "Outstation Cabs Pune to Mumbai",
        description:
            "Rising Cab Service provides Outstation Cabs Pune to Mumbai with smooth highway travel, experienced drivers, and flexible one-way and round-trip options for business and leisure trips."
    },
    {
        name: "Book Outstation Cabs Pune",
        description:
            "Our Book Outstation Cabs Pune system allows instant booking with multiple vehicle choices, transparent pricing, and quick confirmation for hassle-free travel planning."
    },
    {
        name: "Outstation Cab Booking Pune",
        description:
            "Rising Cab Service offers Outstation Cab Booking Pune with easy online reservations, reliable service, and comfortable vehicles for all intercity routes."
    },
    {
        name: "Pune Outstation Cab Service",
        description:
            "Book Pune Outstation Cab Service with Rising Cab Service for safe, comfortable, and affordable travel across all major cities and tourist destinations."
    },
    {
        name: "Best Outstation Cab in Pune",
        description:
            "Rising Cab Service is the Best Outstation Cab in Pune provider offering premium vehicles, experienced drivers, and reliable intercity transportation for all travel needs."
    },
    {
        name: "Online Outstation Cab Booking Pune",
        description:
            "Our Online Outstation Cab Booking Pune system provides instant booking confirmation, transparent fares, and multiple vehicle options for seamless travel planning."
    },
    {
        name: "Cheap Outstation Cabs Pune",
        description:
            "Rising Cab Service offers Cheap Outstation Cabs Pune with affordable pricing, safe travel, and comfortable vehicles for budget-friendly intercity trips."
    },
    {
        name: "24x7 Outstation Cab Service Pune",
        description:
            "Book 24x7 Outstation Cab Service Pune with Rising Cab Service for round-the-clock availability, quick response, and reliable intercity transportation anytime."
    },
    {
        name: "Pune to Mumbai Outstation Cab",
        description:
            "Rising Cab Service provides Pune to Mumbai Outstation Cab with safe highway travel, punctual pickups, and comfortable rides for business and personal travel."
    },
    {
        name: "One Way Outstation Cab Pune",
        description:
            "Our One Way Outstation Cab Pune service offers affordable drop-only travel with no return charges, ideal for flexible intercity journeys."
    },
    {
        name: "Outstation Car Rental Pune",
        description:
            "Rising Cab Service provides Outstation Car Rental Pune with a variety of vehicles including sedans, SUVs, and premium cars for comfortable long-distance travel."
    },
    {
        name: "Best Outstation Cab Booking Near Me Pune",
        description:
            "Find the Best Outstation Cab Booking Near Me Pune with Rising Cab Service for quick booking, reliable drivers, and comfortable intercity travel solutions."
    },
    {
        name: "Cheap Outstation Taxi from Pune",
        description:
            "Our Cheap Outstation Taxi from Pune ensures budget-friendly travel with safe drivers, clean vehicles, and affordable pricing for all destinations."
    },
    {
        name: "Safe Outstation Cab Service Pune",
        description:
            "Rising Cab Service provides Safe Outstation Cab Service Pune with verified drivers, GPS tracking, and strict safety standards for secure travel."
    },
    {
        name: "Book Pune Outstation Cab Online",
        description:
            "Book Pune Outstation Cab Online with Rising Cab Service for instant confirmation, transparent pricing, and hassle-free travel experience."
    },
    {
        name: "Family Outstation Cab Pune",
        description:
            "Our Family Outstation Cab Pune service ensures safe, spacious, and comfortable travel for families with well-maintained vehicles and experienced drivers."
    },
    {
        name: "One Way Outstation Cab Pune",
        description:
            "Rising Cab Service offers One Way Outstation Cab Pune for convenient drop-only travel with affordable fares and flexible destination options."
    },
    {
        name: "Airport to Outstation Cab Pune",
        description:
            "Book Airport to Outstation Cab Pune for direct intercity travel from Pune Airport to any destination with comfortable vehicles and professional drivers."
    }
],

tableData: [
    ["Outstation Taxi Service Pune", "Pune Outstation Taxi"],
    ["Long Distance Taxi Pune", "Intercity Taxi Pune"],
    ["One Way Taxi Pune Outstation", "Round Trip Taxi Pune"],
    ["Outstation Taxi Booking Pune", "Pune to Outstation Taxi"],
    ["Best Outstation Taxi Pune", "Cheap Outstation Taxi Pune"],
    ["SUV Outstation Taxi Pune", "Sedan Outstation Taxi Pune"],
    ["Pune Outstation Taxi Fare", "Luxury Outstation Taxi Pune"],
    ["Corporate Outstation Taxi Pune", "Outstation Taxi Service in Pune"],
    ["Outstation Taxi in Pune", "Outstation Cabs Pune to Mumbai"],
    ["Book Outstation Cabs Pune", "Outstation Cab Booking Pune"],
    ["Pune Outstation Cab Service", "Best Outstation Cab in Pune"],
    ["Online Outstation Cab Booking Pune", "Cheap Outstation Cabs Pune"],
    ["24x7 Outstation Cab Service Pune", "Pune to Mumbai Outstation Cab"],
    ["One Way Outstation Cab Pune", "Outstation Car Rental Pune"],
    ["Safe Outstation Cab Service Pune", "Book Pune Outstation Cab Online"],
    ["Family Outstation Cab Pune", "Airport to Outstation Cab Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Outstation Travel from Pune",
        WhyChoosedescription: "Rising Cab Service provides dependable outstation taxi services from Pune to popular destinations across Maharashtra, Karnataka, Goa, Gujarat, Madhya Pradesh, and other states."
    },
    {
        WhyChooseheading: "Travel to Hundreds of Destinations",
        WhyChoosedescription: "Whether planning a trip to Mumbai, Shirdi, Nashik, Mahabaleshwar, Goa, Kolhapur, Hyderabad, Bangalore, or any other city, we offer comfortable transportation solutions."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way transfers, return journeys, multi-day tours, or customized travel plans based on their schedule and travel requirements."
    },
    {
        WhyChooseheading: "Fleet Suitable for Every Journey",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles to accommodate every type of traveler."
    },
    {
        WhyChooseheading: "Convenient Pickup from Any Pune Location",
        WhyChoosedescription: "We provide doorstep pickup services from homes, hotels, offices, Pune Airport, Railway Station, and all major locations across Pune and PCMC."
    },
    {
        WhyChooseheading: "Long-Distance Travel Made Comfortable",
        WhyChoosedescription: "Well-maintained vehicles, comfortable seating, and experienced drivers help ensure a pleasant journey even on extended travel routes."
    },
    {
        WhyChooseheading: "Suitable for Business and Leisure Trips",
        WhyChoosedescription: "Our outstation taxi services are widely used for corporate travel, family vacations, religious tours, weekend getaways, and group excursions."
    },
    {
        WhyChooseheading: "Professional Service with Transparent Pricing",
        WhyChoosedescription: "Rising Cab Service focuses on customer satisfaction through clear pricing, punctual service, and reliable travel arrangements."
    }
]
};

const faqData = [
    {
        question: "Which destinations can be covered through your outstation taxi service from Pune?",
        answer: "Customers can travel to Mumbai, Shirdi, Nashik, Aurangabad, Mahabaleshwar, Goa, Kolhapur, Hyderabad, Bangalore, Indore, Ujjain, and many other destinations."
    },
    {
        question: "Can travelers reserve a cab for a multi-day tour?",
        answer: "Yes, multi-day travel packages are available for vacations, business visits, pilgrimage tours, and sightseeing trips."
    },
    {
        question: "Are one-way taxi services available from Pune?",
        answer: "Yes, customers can choose both one-way and round-trip travel options according to their itinerary."
    },
    {
        question: "Which vehicle category is suitable for long-distance travel?",
        answer: "Many travelers prefer Ertiga, Innova Crysta, and SUVs for extended journeys due to their comfort and spacious seating."
    },
    {
        question: "Can groups hire larger vehicles for outstation tours?",
        answer: "Yes, Tempo Travellers and group transportation vehicles can be arranged for family tours, corporate outings, and pilgrimage trips."
    },
    {
        question: "Is airport pickup available before starting an outstation trip?",
        answer: "Yes, customers arriving at Pune Airport can directly begin their outstation journey with our pickup service."
    },
    {
        question: "Are drivers experienced in interstate travel routes?",
        answer: "Yes, our drivers regularly operate across multiple states and are familiar with major highways and tourist destinations."
    },
    {
        question: "Can customized sightseeing stops be added during travel?",
        answer: "Yes, itineraries can be personalized to include sightseeing locations, temples, forts, beaches, and tourist attractions."
    },
    {
        question: "When should customers make their reservation?",
        answer: "Advance booking is recommended, especially during weekends, holidays, festive seasons, and peak travel periods."
    },
    {
        question: "How can a Pune outstation taxi be booked?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Patankar",
        feedback:
            "A week-long family tour across Maharashtra was managed exceptionally well. The vehicle remained comfortable throughout the journey, and every travel arrangement was handled professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishnavi Gokhale",
        feedback:
            "For a recent business trip outside Pune, Rising Cab Service delivered a seamless travel experience. Timely service, courteous driver, and smooth highway travel made the journey stress-free.",
        rating: 5
    }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Outstation Taxi Service in Pune",
"image": "https://www.risingcabservice.com/assets/images/outstation-taxi-service-pune.jpg",
"description": "Book Outstation Taxi Service in Pune with Rising Cab Service for long-distance travel, intercity trips, one-way and round-trip journeys. Enjoy safe, reliable, and affordable outstation cab service with sedan, SUV, luxury cars, and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/outstation-taxi-service-pune"
}
};






    return (
        <div>
<Helmet>
  <title>Outstation Taxi Service in Pune | One Way & Round Trip Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Outstation Taxi Service in Pune for long-distance travel, intercity rides, and one-way or round-trip trips. Affordable SUV, sedan, and luxury cab options available for all destinations from Pune."
/>

<meta
 name="keywords"
 content="Outstation taxi service pune, pune outstation taxi, long distance taxi pune, intercity taxi pune, one way taxi pune outstation, round trip taxi pune, outstation taxi booking pune, pune to outstation taxi, best outstation taxi pune, cheap outstation taxi pune, suv outstation taxi pune, sedan outstation taxi pune, pune outstation taxi fare, luxury outstation taxi pune, corporate outstation taxi pune, outstation taxi service in pune, Outstation taxi in pune, Outstation cabs pune to mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationtaxiservicepune;